import DOMPurify from 'dompurify'
import { useBlockRenderContext } from '@/components/blocks'
import type { BlockVisualProps } from '../../Types'
import type { TextBlock } from '@/types/blocks/document/Text'
import './text-visual.css'
import React from 'react'

export function TextVisual({ block }: BlockVisualProps) {
	const { mode } = useBlockRenderContext()

	if (block.type !== 'text') return null

	const textBlock = block as TextBlock
	const { content, alignment = 'left', fontSize, color } = textBlock.properties

	// Mode-dependent empty state
	if (!content || content.trim() === '') {
		if (mode === 'editor') {
			return <div className="text-visual text-visual--empty">Empty text block</div>
		}
		return null
	}

	// Sanitize HTML
	const sanitizedContent = DOMPurify.sanitize(content, {
		ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'u', 'span', 'a'],
		ALLOWED_ATTR: ['href', 'target', 'style']
	})

	// User-configurable styles
	const style: React.CSSProperties = { textAlign: alignment }
	if (fontSize) style.fontSize = `${fontSize}px`
	if (color) style.color = color

	return (
		<div
			className="text-visual"
			style={style}
			dangerouslySetInnerHTML={{ __html: sanitizedContent }}
			data-block-id={textBlock.id}
		/>
	)
}
